// @module TavanoTeam.CSExtensions.CSCertCapture.Model
define('TavanoTeam.CSExtensions.CSCertCapture.Model'
,   [
        'Utils'
    ,   'Backbone'
    ]
,   function(
        Utils
    ,   Backbone
    )
{
    'use strict';

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/CSCertCaptureExt.Service.ss'))
    });
});
